<template>
  <v-os-popup
    class="order-merge-popup"
    v-model="show"
    :title="title"
    @close="close"
  >
    <template v-for="(item1, index) in config.mergeList">
      <template v-for="(item2, key) in item1.orderCommodityUnits">
        <ProductItem
          class="product-item"
          :key="`${index}-${key}`"
          :productInfo="item2"
          :orderNo="config.orderBase.orderNo"
          :tempTerminal="tempTerminal"
          :orderBase="config.orderBase"
        />
      </template>
    </template>
    <template v-slot:footer>
      <div class="footer">
        <v-button size="large" @click="confirm">确定</v-button>
      </div>
    </template>
  </v-os-popup>
</template>

<script>
import ProductItem from './components/product-item'
export default {
  name: 'OrderMergePopup',
  components: {
    ProductItem
  },
  data () {
    return {
      type: '',
      show: false,
      config: {
        orderBase: {},
        mergeList: []
      },
      tempTerminal: ''
    }
  },
  watch: {
    show(val) {
      if (val) {
        const event_id = {
          settle: '132|015|02|077',
          cancel: '132|016|02|077'
        }[this.type]

        this.$track({ event_id })
      }
    }
  },
  computed: {
    title () {
      return {
        cancel: '以下订单需合并取消',
        settle: '以下订单需合并支付'
      }[this.type]
    }
  },
  methods: {
    close() {
      this.show = false
    },
    confirm() {
      this.cb()
      this.close()
    }
  }
}
</script>

<style lang="scss" src="./index.scss" scoped></style>
